import React from "react";
import { MapPin, CircleCheck, Wifi } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const regions = [{
  name: "Adelaide Metro",
  status: "Face-to-Face",
  available: true,
  mode: "in-person"
}, {
  name: "Northern Suburbs",
  status: "Face-to-Face",
  available: true,
  mode: "in-person"
}, {
  name: "Regional South Australia",
  status: "Remote / Telehealth",
  available: true,
  mode: "remote"
}];
export default function OurReach() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="our-reach" ref={ref} className="relative w-full py-24 overflow-hidden bg-background">
      {}
      <div className="pointer-events-none absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/4 opacity-[0.03] dark:opacity-[0.05] select-none">
        <svg width="600" height="600" viewBox="0 0 24 24" fill="currentColor" className="text-foreground w-[400px] h-[400px] md:w-[600px] md:h-[600px]" xmlns="http://www.w3.org/2000/svg">
          {}
          <path d="M3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V2h-2v2H9V2H7v2H5a2 2 0 0 0-2 2zm16 14H5V6h14v14zM12 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
        </svg>
      </div>

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          {}
          <div className={`flex flex-col gap-6 transition-all duration-700 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-4">
              <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
                Service Areas
              </h2>
              <p className="text-lg text-muted-foreground max-w-lg leading-relaxed">Resolve Clinical Services is proudly South Australian. We provide dedicated support across key metropolitan and regional areas, ensuring accessible, high-quality NDIS support where you need it most.</p>
            </div>

            <div className="flex items-center gap-4 text-sm font-medium text-primary">
              <div className="flex items-center gap-2">
                <span className="flex h-2 w-2 rounded-full bg-emerald-500" />
                Accepting New Referrals
              </div>
              <div className="h-4 w-px bg-border" />
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4" />
                Based in Adelaide, SA
              </div>
            </div>
          </div>

          {}
          <div className="grid gap-4 sm:grid-cols-2">
            {regions.map((region, i) => <div key={region.name} data-index={i} className={`transition-all duration-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${200 + i * 100}ms`
          }}>
                <Card className="h-full border-border/60 bg-card/50 backdrop-blur-sm hover:bg-card hover:border-primary/20 hover:shadow-md transition-all duration-300">
                  <CardContent className="p-5 flex flex-col justify-between h-full gap-4">
                    <div className="flex items-start justify-between gap-2">
                      <div className="flex items-center gap-3">
                        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/5 text-primary">
                          {region.mode === "in-person" ? <MapPin className="h-5 w-5" /> : <Wifi className="h-5 w-5" />}
                        </div>
                        <span className="font-semibold text-foreground">
                          {region.name}
                        </span>
                      </div>
                    </div>

                    <div className="flex items-center justify-between pt-2 border-t border-border/50">
                      <Badge variant={region.mode === "in-person" ? "default" : "secondary"} className={`pointer-events-none ${region.mode === "in-person" ? "bg-primary/90 hover:bg-primary/90" : "bg-secondary hover:bg-secondary text-secondary-foreground"}`}>
                        {region.status}
                      </Badge>
                      {region.available && <CircleCheck className="h-4 w-4 text-emerald-500/80" />}
                    </div>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}